import styled from "styled-components";
import { devicesNovo } from "../../utils/styled/_variables.styled";

export const EmbedThumbContainer = styled.div`
    .embed-container{
        width: 100%;

        .embed-style{
            position: relative; 
            width: 100%; 
            height: 100%;

            .embed-image{
                width: 100%; 
                display: flex;
                background-image: linear-gradient(45deg, rgb(0, 0, 0) 0%, rgb(0 0 0) 100%);

                img{
                    width: 100%;
                    height: auto;
                    objectFit: cover;
                    -webkit-mask-image: linear-gradient(to top, #000000a6 25%, black 100%);
                    cursor: pointer;
                    /* aspect-ratio: 1208/545;

                    @media ${devicesNovo.mobile} {
                    aspect-ratio: 1/1;
                    } */
                }
                
                .buttonEmbed{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: rgb(255 255 255 / 0%);
                    border: none;
                    border-radius: 50%;
                    padding: 10px 10px 10px 15px;
                    cursor: pointer;
                    font-size: 32px;
                    color: #FFF;
                    border: 6px solid #FFF;
                }
            }
            
            div{
                width: 100%;
                iframe{
                    width: 100%; 
                }
            
            }

        }


    }
`;
